var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-chip',{staticClass:"tw-font-bold",attrs:{"label":"","color":_vm.colorClass}},[_vm._v(" "+_vm._s(_vm.formatedDate)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }